import { useEffect, useRef } from "react";

const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

/** Right-side drawer with dialog semantics: named, initial focus, focus containment, Escape to close, focus restored on close. */
export function A11yDrawer({ labelId, onClose, testid, children }) {
  const panel = useRef(null);
  const close = useRef(onClose);
  close.current = onClose;
  useEffect(() => {
    const prev = document.activeElement;
    const el = panel.current;
    (el.querySelector("[data-autofocus]") || el.querySelector(FOCUSABLE) || el).focus();
    const onKey = (e) => {
      if (e.key === "Escape") { e.stopPropagation(); close.current(); return; }
      if (e.key !== "Tab") return;
      const f = [...el.querySelectorAll(FOCUSABLE)].filter((n) => n.offsetParent !== null);
      if (!f.length) return;
      const [first, last] = [f[0], f[f.length - 1]];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    el.addEventListener("keydown", onKey);
    return () => { el.removeEventListener("keydown", onKey); if (prev && prev.focus) prev.focus(); };
  }, []);
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex justify-end" onClick={onClose} data-testid={testid}>
      <div ref={panel} role="dialog" aria-modal="true" aria-labelledby={labelId} tabIndex={-1}
        className="w-full max-w-lg bg-white h-full overflow-auto p-6 outline-none" onClick={(e) => e.stopPropagation()}>
        {children}
      </div>
    </div>
  );
}
